import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, ActiveUserAuthGuard } from './../shared/services/auth-guard.service';
import { AuthService } from '../shared/services/authentication.service';

import { PagesError404Component } from '../shared/views/error/404/pages-error-404/pages-error-404.component';
import { PagesError403Component } from '../shared/views/error/403/pages-error-403/pages-error-403.component';
import { ResetPasswordComponent, ForgotPasswordComponent } from './../shared/views/users/reset-password/reset-password.component';
import { DownloadsComponent } from './../shared/views/downloads/downloads.component';
import { CallbackComponent } from '../shared/views/callback/callback.component';
import { PublicCaqComponent } from 'shared/components/public-caq/public-caq.component';
import { UserDetailFormComponent } from 'shared/components/user-detail-form/user-detail-form.component';
const defaultTitle = ' - ServiceO'

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: 'callback',
        component: CallbackComponent,
        data: {
            appName: 'msp',
        }
    },
    {
        path: 'pms',
        canActivate: [AuthGuard],
        loadChildren: './pms/pms-msp.module#PMSModule',
        resolve: {
            currentUser: AuthService
        },
        data: {
            title: 'Dashboard ' + defaultTitle,
            permissions: ['partner', 'internal']
        }
    },
    {
        path: 'vms',
        canActivate: [AuthGuard],
        loadChildren: './vms/vms-msp.module#VMSModule',
        resolve: {
            currentUser: AuthService
        },
        data: {
            title: 'Dashboard ' + defaultTitle,
            permissions: ['vendor', 'internal', 'customer']
        }
    },
    {
        path: 'login',
        canActivate: [ActiveUserAuthGuard],
        loadChildren: '../shared/views/authentication/authentication.module#AuthenticationModule',
        data: {
            appName: 'msp',
        }
    },
    // {
    //     path: 'users',
    //     loadChildren: '../shared/views/users/users.module#UsersModule',
    //     canActivate: [AuthGuard],
    //     resolve: {
    //         currentUser: AuthService
    //     },
    //     data: {
    //         title: 'Users ' + defaultTitle,
    //         permissions: ['vendor', 'partner', 'internal', 'customer']
    //     }
    // },
    {
        path: 'reset',
       // canActivate: [ActiveUserAuthGuard],
        component: ResetPasswordComponent
    },
    {
        path: 'reset-password',
       // canActivate: [ActiveUserAuthGuard],
        component: ForgotPasswordComponent
    },
    {
        path: 'app',
        loadChildren: './common/common-msp.module#CommonModule',
        canActivate: [AuthGuard],
        resolve: {
            currentUser: AuthService
        },
        data: {
            title: 'Common ' + defaultTitle,
            permissions: ['internal']
        }
    },
    {
        path: 'downloads/:documentId',
        canActivate: [AuthGuard],
        component: DownloadsComponent,
        resolve: {
            currentUser: AuthService
        },
        data: {
            title: 'Downloads ' + defaultTitle,
            permissions: ['internal']
        }
    },
    {
        path: 'dwn/:documentId',
        canActivate: [AuthGuard],
        component: DownloadsComponent,
        resolve: {
            currentUser: AuthService
        },
        data: {
            title: 'Downloads ' + defaultTitle,
            permissions: ['internal']
        }
    },
    {
        path: 'public/caq/:jobId/:appId',
        component: PublicCaqComponent,
        data: {
            title: 'Job Openings ' + defaultTitle
        }
    },
    {
        path: 'automated/form/:usersfdcId',
        component: UserDetailFormComponent,
        data: {
            title: 'User Details Form' + defaultTitle
        }
    },
    {
        path: 'page-not-found',
        component: PagesError404Component
    },
    {
        path: 'pages-error-403',
        component: PagesError403Component
    },
    {
        path: 'shared',
        loadChildren: '../shared/views/shared-file/shared-file.module#SharedFileModule',
        resolve: {
            currentUser: AuthService
        }
    },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
        data: {
            appName: 'msp',
        }
    },
    {
        path: '**',
        redirectTo: 'page-not-found'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ],
    exports: [
        RouterModule
    ],
})

export class AppRoutingModule { }
